// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"2ed78d17","878":"5c014649"}[chunkId] + ".chunk.js";
};